import "./assets/styles/main.css";
import "@vueform/multiselect/themes/default.css";
import "./assets/animation.js";
import "./index.css";
import "vue-toastification/dist/index.css";

import { createApp } from "vue";
import App from "./App.vue";
import Toast from "vue-toastification";
import router from "./core/router/index.js";
import i18n from "./i18n.js";

const app = createApp(App);

app.mixin({
  methods: {
    formatNumber(value) {
      return new Intl.NumberFormat().format(value);
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      return String(dateStr).split("T")[0];
    },

    twelveHourFormat(time24) {
      if (!time24 || typeof time24 !== "string" || !time24.includes(":")) {
        return time24;
      }
    
      const [hours, minutes] = time24.split(":").map(Number);
    
      if (isNaN(hours) || isNaN(minutes)) {
        return time24;
      }
    
      const period = hours >= 12 ? "PM" : "AM";
      const hours12 = hours % 12 || 12;
      const formattedMinutes = minutes.toString().padStart(2, "0");
    
      let swahiliTime = "";
    
      if (hours >= 4 && hours < 6) {
        swahiliTime = "ALFAJIRI";
      } else if (hours >= 6 && hours < 12) {
        swahiliTime = "ASUBUHI";
      } else if (hours >= 12 && hours < 16) {
        swahiliTime = "MCHANA";
      } else if (hours >= 16 && hours < 19) {
        swahiliTime = "JIONI";
      } else {
        swahiliTime = "USIKU";
      }
    
      return `${hours12}:${formattedMinutes} ${period} ${swahiliTime}`;
    }
    
  },
});

app.use(router);
app.use(Toast);
app.use(i18n);

app.mount("#app");
